import { lazy } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';

// routes
import AuthenticationRoutes from './MaintenanceRoutes';
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';
import OnboardingRoutes from './OnboardingRoutes';
import { RouteObject } from 'react-router-dom';
import { DASHBOARD_PATH } from 'config';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';
import OpsConsoleGuard from 'utils/route-guard/OpsConsoleGuard';
import RouteErrorBoundary from 'views/pages/maintenance/RouteErrorBoundary';

const OpsConsole = Loadable(lazy(() => import('views/ops/OpsConsole')));
const PluginAuth = Loadable(lazy(() => import('views/plugin-auth')));
const NativeLogin = Loadable(lazy(() => import('views/pages/authentication/NativeLogin')));

/** popup הנפקת טוקן לתוסף הפיירברי — מנהל בעצמו הפניית לא-מחוברים ל-login, לכן בלי AuthGuard */
const pluginAuthRoute: RouteObject = {
  path: '/plugin-auth',
  element: <PluginAuth />,
  errorElement: <RouteErrorBoundary />,
};

/** נפתח בדפדפן המערכת מאפליקציית המובייל לצורך Google OAuth; חייב להיות זמין גם למחובר וגם ללא-מחובר */
const nativeLoginRoute: RouteObject = {
  path: '/native-login',
  element: <NativeLogin />,
  errorElement: <RouteErrorBoundary />,
};

/** מפורש ולפני LoginRoutes — אחרת GuestGuard על עץ `/` מפנה משתמש מחובר לדף הבית לפני ש-MainRoutes נבדק */
const opsConsoleRoute: RouteObject = {
  path: '/ops-console',
  element: (
    <AuthGuard>
      <OpsConsoleGuard>
        <OpsConsole />
      </OpsConsoleGuard>
    </AuthGuard>
  ),
  errorElement: <RouteErrorBoundary />,
};

// ==============================|| ROUTING RENDER ||============================== //

const notFoundRoute: RouteObject = {
  path: '*',
  element: <Navigate to={DASHBOARD_PATH} replace />,
};

const router = createBrowserRouter(
  [opsConsoleRoute, pluginAuthRoute, nativeLoginRoute, LoginRoutes, OnboardingRoutes, MainRoutes, AuthenticationRoutes, notFoundRoute],
  {
    basename: import.meta.env.VITE_APP_BASE_NAME,
  },
);

export default router;
